import angular from "angular";
import { NaviService } from "../services";

/**
 * Shows the element based on Sitemap parameters:
 * Currently supported are Visibility and isFullWidth as interpreted by SitemapHelper.getVisibility() method,
 * e.g. "hidden" includes HiddenReadOnly, Disabled and current node not resolved situations besides Hidden.
 * See description of SitemapHelper.getVisibility() for exact details.
 * @example
 * ```html
 * <div *sxy-if-sitemap="hidden">Shown if the current page is hidden (including HiddenReadOnly, Disabled and current node not resolved)</div>
 * <div *sxy-if-sitemap="visible">Shown if the current page is visible (visibility null or Visible).</div>
 * ```
 */
export class IfSitemapDirective implements angular.IDirective {

  /**
   * Factory method for the directive creation.
   * @ignore
   */
  public static sxyIfSitemap() {
    const factory = (naviService: NaviService, ngIfDirective: any) => new IfSitemapDirective(naviService, ngIfDirective);
    factory.$inject = ["NaviService", "ngIfDirective"];
    return factory;
  }

  /**
   * Directive restrictions.
   * @ignore
   */
  public restrict;

  /**
   * Transclusion.
   * @ignore
   */
  public transclude;

  /**
   * Priority parameter.
   * @ignore
   */
  public priority;

  /**
   * Terminal parameter.
   * @ignore
   */
  public terminal;

  /** Uses the original ngIf class as bases for the functionality. */
  private ngIf: any;

  /**
   * Creates a new instance of the directive.
   */
  constructor(private naviService: NaviService, ngIfDirective: any) {
    this.ngIf = ngIfDirective[0];
    this.restrict = this.ngIf.restrict;
    this.transclude = this.ngIf.transclude;
    this.priority = this.ngIf.priority;
    this.terminal = this.ngIf.terminal;
  }

  /**
   * Link function for the directive.
   * @ignore
   */
  public link(scope: any, element: any, attrs: any) {
    const value = attrs.sxyIfSitemap;
    const prop = attrs.prop;
    attrs.ngIf = () => {
      if (prop && prop != "visibility") {
        const compareTo = this.naviService.current.node?.[prop]?.toString();
        if (compareTo?.trim() && value?.trim()) {
          return compareTo.trim().toLowerCase() == value.trim().toLowerCase();
        }
        return false;
      } else {
        return this.naviService.current.getVisibility(value);
      }
    };
    // eslint-disable-next-line prefer-spread, prefer-rest-params
    this.ngIf.link.apply(this.ngIf, arguments);
  }
}
